import script from "./TabUnitsDoneByLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./TabUnitsDoneByLocation.vue?vue&type=script&setup=true&lang=js"

import "./TabUnitsDoneByLocation.vue?vue&type=style&index=0&id=4e9ec9c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9ec9c2"]])

export default __exports__